import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SpsOptionListModule } from "./sps-option-list.module";

import { SpsSelectComponent } from "../components/index";

@NgModule({
    imports: [CommonModule, SpsOptionListModule, FormsModule],
    declarations: [SpsSelectComponent],
    exports: [SpsSelectComponent]
})
export class SpsSelectModule {}
